/**
 * Product Upsell
 * Handles the product upsell functionality including adding/removing items
 */

(function() {
  'use strict';

  function initUpsell() {
    const upsellContainer = document.querySelector('[data-upsell]');
    
    if (!upsellContainer) {
      return;
    }

    const addButton = upsellContainer.querySelector('[data-upsell-add]');
    const removeButton = upsellContainer.querySelector('[data-upsell-remove]');

    if (!addButton || !removeButton) {
      return;
    }

    function handleAdd() {
      const upsellID = upsellContainer.getAttribute('data-upsell');
      upsellContainer.classList.add('added');
      window.upsellID = upsellID;
    }

    function handleRemove() {
      upsellContainer.classList.remove('added');
      window.upsellID = null;
    }

    addButton.addEventListener('click', handleAdd);
    removeButton.addEventListener('click', handleRemove);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUpsell);
  } else {
    initUpsell();
  }
})();
